import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// Module-level guard survives StrictMode double-mount and remounts.
let lastPath = null;

// Full-screen Kaaba animation shown briefly on every route change.
const KaabaTransition = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [phase, setPhase] = useState("enter");

  useEffect(() => {
    if (lastPath === null) {
      lastPath = location.pathname;
      return; // skip on very first load
    }
    if (lastPath === location.pathname) return; // no real change
    lastPath = location.pathname;

    setVisible(true);
    setPhase("enter");
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    const exitTimer = setTimeout(() => setPhase("exit"), 750);
    const hideTimer = setTimeout(() => setVisible(false), 1200);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div className={`kaaba-transition ${phase === "enter" ? "transition-enter" : "transition-exit"}`}>
      <div className="kaaba-scene relative flex items-center justify-center">
        <div className="kaaba-ring" />
        <div className="kaaba">
          <div className="face front" />
          <div className="face back" />
          <div className="face right" />
          <div className="face left" />
          <div className="face top" />
        </div>
      </div>
      <p className="mt-16 font-serif text-2xl text-white/90">
        <span style={{ color: "#E4CE96" }}>Fly</span> Jannah
      </p>
      <p className="mt-1 text-white/50 text-xs tracking-[0.3em] uppercase">Labbayk Allahumma Labbayk</p>
    </div>
  );
};

export default KaabaTransition;
